import { Injectable } from '@angular/core';
import {PlatformService} from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class GtmEventsService {

  constructor(private _platformService: PlatformService) { }

  pushPageView(title: string, customUrl: string | null = null) {
    if (this._platformService.isServer()) {
      return;
    }

    (window?.dataLayer ?? []).push({
      event: 'virtualPageView',
      pageUrl: customUrl ?? decodeURIComponent(window.location.href),
      pageTitle: title,
      referrer: decodeURIComponent(document.referrer)
    });
  };

  pointOfInterestViewed(title: string, location: 'map' | 'list') {
    if (this._platformService.isServer()) {
      return;
    }

    (window?.dataLayer ?? []).push({
      event: 'pointOfInterestViewed',
      poiTitle: title,
      poiLocation: location,
    });
  }
}
